import React from 'react'

const FireBaseContext = React.createContext({})

export const FireBaseProvider = FireBaseContext.Provider
export const FireBaseConsumer = FireBaseContext.Consumer
export default FireBaseContext



// WEBPACK FOOTER //
// ./src/context/fireBaseContext.js